import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Studying scrubs",
  "description": "",
  "published": "2007-06-06T00:00:00.000Z",
  "redirect_from": ["/blog/studying-scrubs/swizec/196"],
  "categories": "life",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Been studying like mad for the past few days but oh that's not too interesting you don't want to know.`}</p>
    <p>{`Apart of studying I've also been watching a lot of lovably stolen Scrubs, I wouldnt' steal it if our television would air it but hey, they're stupid and don't, their fault. So season six is rather awesome and jsut might be my favourite yet. The story arc is pretty nice in this one as it stretches pretty much the whole season. I've in general noticed that with every next season the episodes are more intraconnected.`}</p>
    <p>{`It's interesting to notice how everyone thought it'd be the last season becauset here are many parts where people reminisce about the last six years of their life together and characters in sitcoms simply don't do that if it's not about to end. I'm glad it didn't.`}</p>
    <p>{`But why did they have to put such a huge cliff hanger in the end? I'm hungering for the seventh season and they haven't even started filming it yet!`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      